import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slug',
})
export class SlugPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    return value
      .toLowerCase()
      .trim()

      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'd')

      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')

      .replace(/^-+|-+$/g, '');
  }
}
